import './RSApprovalFail.scss';

export function RSApprovalFail() {
  return (
    <div className="rs-approval-fail-warning">ERROR: No Approval</div>
  );
}
